import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import GradeRecordRepository from '../../repositories/GradeRecordRepository';
import GradeRecordDataRepository from '../../../data/repositories/GradeRecordRepository';

export default function* getCoursesGradeRecordSaga(): any {
  try {
    yield put({ type: Types.GET_COURSES_GRADE_RECORD_REQUEST });
    const profileRepository: GradeRecordRepository =
      new GradeRecordDataRepository();
    const coursesGradeRecordResponse = yield call(
      profileRepository.getCoursesGradeRecord
    );
    if (!coursesGradeRecordResponse) {
      throw new Error(
        'No se pudo obtener el registro de calificaciones de los cursos.'
      );
    }
    yield put({
      type: Types.GET_COURSES_GRADE_RECORD_SUCCESS,
      data: coursesGradeRecordResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_COURSES_GRADE_RECORD_FAILURE,
      error:
        'Ocurrió un error al obtener el registro de calificaciones de los cursos.'
    });
  }
}
